
<template>

  <body>
  <div class="header"></div>
  <img class="rightTopBg" src="../../../static/images/openPlatform/rightTopBg.png" alt="">
  <div class="section1">
    <div class="wrapper">
      <div class="leftBg">
        <img src="../../../static/images/openPlatform/part1.png">
      </div>
      <div class="describe">
        <p class="line1">开放连接更多</p>
        <p class="line2">Opened up Connect More</p>
        <p class="line3">H5 / API / 二维码 / 收银台 / SASS</p>
      </div>
    </div>
  </div>
  <div class="section2">
    <div class="wrapper">
      <h3>合作流程</h3>
      <div class="process">
        <div class="process1">
          <img src="../../../static/images/openPlatform/icon1.png" alt="">
          <p>1</p>
          <p>注册认证</p>
        </div>
        <div class="line"></div>
        <div class="process2">
          <img src="../../../static/images/openPlatform/icon2.png" alt="">
          <p>2</p>
          <p>选择保险产品和接入场景</p>
        </div>
        <div class="line"></div>
        <div class="process3">
          <img src="../../../static/images/openPlatform/icon3.png" alt="">
          <p>3</p>
          <p>获得保险推广能力</p>
        </div>
      </div>
    </div>
  </div>
  <div class="section3">
    <div class="wrapper">
      <h3>连接场景定义保险</h3>
      <div class="describe">
        <p class="line1">Platform</p>
        <p class="line2">平台</p>
        <p class="line3">当用户在旅游平台、购物平台，购买门票、境内游、境外游行程等购买场景时调用开发平台API插件激发用户购买保险意识。</p>
      </div>
    </div>
  </div>
  <div class="section4">
    <div class="wrapper">
      <div class="describe">
        <p class="line1">Life scene</p>
        <p class="line2">生活场景</p>
        <p class="line3">用户通过线下微信扫一扫，扫描海报、X展架、宣传单、楼梯广告里面的二维码进行轻松投保。</p>
      </div>
    </div>
  </div>
  <div class="section5">
    <div class="wrapper">
      <div class="describe">
        <p class="line1">Insurance Mart</p>
        <p class="line2">保险商城</p>
        <p class="line3">你的APP、公众号、小程序上需要赋予多个或销售保险产品，可从通过H5方式一个链接轻松接入。</p>
      </div>
    </div>
  </div>
  <div class="section6">
    <div class="wrapper">
      <h3>接入方式</h3>
      <div class="content">
        <ul>
          <li>
            <div>
              <img src="../../../static/images/openPlatform/icon4.png" alt="">
              <p class="line1">H5</p>
              <p class="line2">无需开发</p>
              <p class="line3">通过链接快速进入</p>
            </div>
          </li>
          <li>
            <div>
              <img src="../../../static/images/openPlatform/icon5.png" alt="">
              <p class="line1">API</p>
              <p class="line2">轻量开发</p>
              <p class="line3">商户具备开发能力标准接口轻松开发</p>
            </div>
          </li>
          <li>
            <div>
              <img src="../../../static/images/openPlatform/icon6.png" alt="">
              <p class="line1">二维码</p>
              <p class="line2">无需开发</p>
              <p class="line3">随时申请马上使用</p>
            </div>
          </li>
          <li>
            <div>
              <img src="../../../static/images/openPlatform/icon7.png" alt="">
              <p class="line1">收银台</p>
              <p class="line2">轻量开发</p>
              <p class="line3">解决保险行业结算问题</p>
            </div>
          </li>
          <li>
            <div>
              <img src="../../../static/images/openPlatform/icon8.png" alt="">
              <p class="line1">SAAS</p>
              <p class="line2">无需开发</p>
              <p class="line3">程序猿在努力内测当中，敬请期待</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="footer"></div>
  <div id="goToTop">
    <a href="javascript:;">
      <img src="../../../static/images/openPlatform/returnTop.png">
      <p>返回顶部</p>
    </a>
  </div>
  </body>

</template>
<script>
    export default {
        name: "indexTwo",
        data() {
            return{
            }
        },

        methods: {
        },
        mounted() {
        }
    }
</script>

<style scoped>
  @import "../../../static/css/openPlatform/index.css";
  @import "../../../static/css/openPlatform/bootstrap.min.css";
  @import "../../../static/css/openPlatform/login.css";


</style>



// WEBPACK FOOTER //
// src/components/openPlatform/indexTwo.vue